import { render, staticRenderFns } from "./Detail-Employee.vue?vue&type=template&id=d476c96c&"
import script from "./Detail-Employee.vue?vue&type=script&lang=js&"
export * from "./Detail-Employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports